import { Injectable } from '@angular/core';
import { ApplyingBonusFacade } from '@checkout-v2/data-access';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApplyingBonusService {
  constructor(private applyingBonusFacade: ApplyingBonusFacade) {}

  setApplyingBonus(value: number): void {
    this.applyingBonusFacade.setApplyingBonus(value);
  }

  getApplyingBonus(): Observable<number> {
    return this.applyingBonusFacade.getApplyingBonus();
  }
}
